import React from "react";
import {
  Dialog,
  Box,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import ModalHeaderTitle from "../ModalHeader/ModalHeaderTitle";
import LabelValueDisplay from "../LabelValue/LabelValueDisplay";
import { SxProps } from "@mui/system";
import "./BaseModal.css";
import refreshIcon from '../../../../../asset/image/refresh-new.svg';
import disabledRefreshIcon from '../../../../../asset/image/disabled-refresh-new.svg';
import EdgeLinkIcon from "../../../../../asset/image/EdgeLinkIcon.svg"
import EdgeLinkIconDisabled from "../../../../../asset/image/linkDisabled.svg"
import GradientButton from "../GradientButton/GradientButton";
var Loader = require("react-loader");

interface BaseModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  rawTitleOnly?: boolean;
  width?: string;
  height?: string;
  maxWidth?: string;
  titleSx?: SxProps;
  titleComponent?: React.ReactNode;
  showOnlineStatus?: boolean;
  onlineStatusText?: string;
  lastSeen?: string;
  showRefreshIcon?: boolean;
  setRefreshIconClicked?: any;
  refreshIconClicked?: any;
  setRefreshTrigger?: any;
  onConnectToEdge?: any;
  isEssential?: boolean;
  showOnlineOffline?: boolean;
  showKonnectStatusWithHeader?: boolean;
  syncStatus?: string;
  showSyncStatus?: boolean;
  syncProps?: {
    showSyncIcon: boolean,
    onSyncClick: () => void,
    isSyncing: boolean,
    setIsSyncing: React.Dispatch<React.SetStateAction<boolean>>;
  };
  showLoader?: boolean;
}

export default function BaseModal({
  open,
  onClose,
  title,
  children,
  rawTitleOnly = false,
  width = '100%',
  height = 'auto',
  maxWidth,
  titleSx,
  titleComponent,
  showOnlineStatus,
  showOnlineOffline,
  onlineStatusText,
  lastSeen,
  showRefreshIcon,
  setRefreshIconClicked,
  refreshIconClicked,
  setRefreshTrigger,
  onConnectToEdge,
  isEssential,
  showKonnectStatusWithHeader,
  syncStatus,
  showSyncStatus,
  syncProps,
  showLoader=false
}: BaseModalProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { showSyncIcon, onSyncClick, isSyncing, setIsSyncing } = syncProps || {};

  const handleRefreshClick = () => {
    if (!refreshIconClicked) return;

    setRefreshIconClicked(false);
    setRefreshTrigger(prev => prev + 1);

    setTimeout(() => {
      setRefreshIconClicked(true);
    }, 10000);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={!width}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: width || "auto",
          height: height || "480px",
          maxWidth: `${maxWidth || (width ? "1080px" : "")} !important`,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          borderRadius: "10px !important",
        },
      }}
    >
      <Box className="modal-wrapper">
        <Box className="modal-header">
          <Box className="modal-header-content">
            {titleComponent ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {titleComponent}
              </Box>
            ) : (
              <ModalHeaderTitle
                title={title}
                rawTitleOnly={rawTitleOnly}
                sx={titleSx}
                showKonnectStatusWithHeader={showKonnectStatusWithHeader}
              />
            )}

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {showRefreshIcon && refreshIconClicked ? <img onClick={handleRefreshClick} src={refreshIcon} alt="refresh" style={{ paddingRight : '10px', cursor: 'pointer'}} /> : showRefreshIcon && !refreshIconClicked ? <img src={disabledRefreshIcon} style={{ paddingRight : '10px', cursor: 'auto'}} /> : null}

              
                <LabelValueDisplay
                  label=""
                  value={showOnlineStatus ? "Online": "Offline"}
                  valueType="status"
                  lastSeen={lastSeen}
                  show={showOnlineOffline} 
                />
                <LabelValueDisplay
                  label=""
                  value={syncStatus}
                  valueType="syncStatus"
                  show={showSyncStatus} 
                />
              
              {/* {showOnlineStatus && !isEssential  ?
                    <a className="vessel_table_cell--portal_link" onClick={() => onConnectToEdge()}>
                        <img src={EdgeLinkIcon} title="Portal" />
                    </a> :
                    <a>
                        <img src={EdgeLinkIconDisabled} title="Portal" />
                    </a>
                } */}
              {showLoader && <div className="haLoader">
                <Loader radius={4} length={5} lines={10} width={2} color={"#264C86"} />
              </div>}

              {showSyncIcon && <GradientButton label={"Sync"} disabled={isSyncing} onClick={() => onSyncClick?.()} />}
              
              <IconButton onClick={onClose} className="close-icon-base">
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>

        {children}
      </Box>
    </Dialog>
  );
}
